import { useEffect, useState } from 'react';

/**
 * 一定間隔で再描画させるだけのフック。
 * 再生位置はサーバの宣言から自分で計算するため、進捗バーを動かすには
 * ローカルで時計を刻む必要がある。
 */
export function useTick(intervalMs = 250): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return now;
}
